import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'
import { color } from "../../../WEBContent/Color";
import { icon } from '../../../WEBContent/Icon';
import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const doc_type = useRef(null);
    const array_epis = useRef(null);

    const type_active = useRef(null);
    const types_actives = useRef(null);
    const dados_actives = useRef(null);
    const filter_section = useRef(null);
    const [refresh, setRefresh] = useState(0);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [lang, set_lang] = useState('pt');
    const { pathname } = useLocation()
    

    const filtered_data = (Array.isArray(array_epis.current) && array_epis.current.length > 0 ? array_epis.current : []).filter(row => {
        if (filter_section.current === 'entregas') {
            return row.info?.edition_archive_entregas !== undefined;
        }
        if (filter_section.current === 'devolucoes') {
            return row.info?.edition_archive_devolucoes !== undefined;
        }
        return true;
    });

    const get_info = async () => {

        let res_types = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/epi_type`)

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(async res => {
                if (Array.isArray(res.data)) {
                    setData(res.data)

                    console.log('res.data', res.data)
                    let i = 0
                    let aux_array = []
                    for await (let aux of res.data) {
                        if (Array.isArray(aux.info.edition_archive_entregas) && aux.info.edition_archive_entregas.length > 0) {
                            for await (let aux_2 of aux.info.edition_archive_entregas) {

                                let aux_deadline = ''
                                if (Array.isArray(res_types.data) && aux_2?.epi_entregue?.id !== undefined) {

                                    let aux_api_type = res_types.data.find(el => parseInt(el.id) === parseInt(aux_2.epi_entregue.id))

                                    if (aux_api_type !== undefined && aux_api_type !== null && aux_api_type?.info?.duracao !== undefined && aux_api_type?.info?.duracao !== null && aux_api_type.info.duracao !== '') {
                                        const d = new Date(aux_2.data_entrega.split('T')[0]);
                                        d.setDate(d.getDate() + parseInt(aux_api_type.info.duracao));
                                        aux_deadline = d.getFullYear() + '-' + (parseInt(d.getMonth()) + 1).toString().padStart(2, '0') + '-' + (d.getDate().toString().padStart(2, '0'))
                                    }
                                }

                                aux_array.push({
                                    id: i++,
                                    info: {
                                        id: aux.id,
                                        company: aux.info.contacts.company,
                                        responsable: aux.info.responsable.create,
                                        edition_archive_entregas: aux_2,
                                        deadline: aux_deadline
                                    }
                                })
                            }
                        }
                        if (Array.isArray(aux.info.edition_archive_devolucoes) && aux.info.edition_archive_devolucoes.length > 0) {
                            for await (let aux_2 of aux.info.edition_archive_devolucoes) {

                                let dias_uso = null;
                                let excede_prazo = false;
                                let excede_quantidade = false;

                                if (aux_2?.data_entrega_ref && aux_2?.data_devolucao) {
                                    dias_uso = Math.round(
                                        (new Date(aux_2.data_devolucao) - new Date(aux_2.data_entrega_ref)) / (1000 * 60 * 60 * 24)
                                    );
                                    excede_prazo = dias_uso > 730;
                                }

                                if (aux_2?.quantidade_entregue_ref !== '' && aux_2?.quantidade_devolvida !== '') {
                                    excede_quantidade = parseFloat(aux_2?.quantidade_devolvida ?? 0) > parseFloat(aux_2?.quantidade_entregue_ref ?? 0);
                                }

                                aux_array.push({
                                    id: i++,
                                    info: {
                                        id: aux.id,
                                        company: aux.info.contacts.company,
                                        responsable: aux.info.responsable.create,
                                        edition_archive_devolucoes: aux_2,
                                        dias_uso,
                                        excede_prazo,
                                        excede_quantidade,
                                    }
                                })
                            }
                        }
                    }
                    console.log('aux_array', aux_array)
                    set_dados(array_epis.current = aux_array)




                }
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            console.log('1111')
            await get_info()
            console.log('2222')

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_type = (id) => {

        if (id !== '') {

            let aux = doc_type.current.filter(e => parseInt(e.id) === parseInt(id))

            return aux[0].info.name
        }
        else {
            return ''
        }

    }

    const change_type = (id) => {

        set_dados(type_active.current = id)
        let aux = data.filter(e => parseInt(e.info.settings.doc_type) === parseInt(id))
        set_dados(dados_actives.current = aux)

    }

    const columns = [
        {
            id: 'company',
            name: language[lang].company,
            selector: 'info.company.name',
            width: '15% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}>
                    {row.info.company.name}
                </Link>
            ),
        },
        {
            id: 'createdBy',
            name: language[lang].createdBy,
            selector: 'info.responsable.name',
            width: '15% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}>
                    {row.info.responsable.name}
                </Link>
            ),
        },
        {
            id: 'epi',
            name: language[lang].epi ?? 'EPI',
            width: '10% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
            cell: row => (
                <span>
                    {row?.info?.edition_archive_entregas?.epi_entregue?.label
                        ?? row?.info?.edition_archive_devolucoes?.epi_devolvido?.label
                        ?? '—'}
                </span>
            ),
        },
        {
            id: 'date_1',
            name: language[lang].field_date,
            width: '10% !important',
            minWidth: '120px !important',
            sortable: true,
            center: true,
            cell: row => (
                <span style={{ fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums' }}>
                    {row?.info?.edition_archive_entregas?.data_entrega
                        ? row.info.edition_archive_entregas.data_entrega.split('T')[0]
                        : row?.info?.edition_archive_devolucoes?.data_devolucao
                            ? row.info.edition_archive_devolucoes.data_devolucao.split('T')[0]
                            : '—'}
                </span>
            ),
        },
        {
            id: 'data_devolucao',
            name: language[lang].data_devolucao ?? 'Data Devolução',
            width: '10% !important',
            minWidth: '120px !important',
            sortable: true,
            center: true,
            cell: row => (
                <span style={{ fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums' }}>
                    {/* entregas: show estimated (data_entrega + 730) */}
                    {row?.info?.edition_archive_entregas?.data_entrega
                        ? row.info.deadline ?? '—'
                        : row?.info?.edition_archive_devolucoes?.data_devolucao
                            ? row.info.edition_archive_devolucoes.data_devolucao.split('T')[0]
                            : '—'
                    }
                </span>
            ),
        },
        {
            id: 'dias_uso',
            name: language[lang].dias_uso ?? 'Dias de Uso',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
            cell: row => (
                row?.info?.dias_uso !== null && row?.info?.dias_uso !== undefined ? (
                    <span className={row.info.excede_prazo ? 'text-danger fw-bold' : ''}>
                        {row.info.dias_uso} {language[lang].days ?? 'dias'}
                        {row.info.excede_prazo &&
                            <i className="bi bi-exclamation-triangle-fill text-danger ms-1"></i>
                        }
                    </span>
                ) : '—'
            ),
        },
        {
            id: 'quantidade',
            name: language[lang].quantidade ?? 'Quantidade',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
            cell: row => (
                row?.info?.edition_archive_entregas !== undefined ? (
                    // entrega row: show quantidade_entregue
                    <span>{row.info.edition_archive_entregas?.quantidade_entregue ?? '—'}</span>
                ) : row?.info?.edition_archive_devolucoes !== undefined ? (
                    // devolucao row: show quantidade_devolvida with warning if exceeded
                    <span className={row.info.excede_quantidade ? 'text-danger fw-bold' : ''}>
                        {row.info.edition_archive_devolucoes?.quantidade_devolvida ?? '—'}
                        {row.info.excede_quantidade &&
                            <i className="bi bi-exclamation-triangle-fill text-danger ms-1"></i>
                        }
                    </span>
                ) : '—'
            ),
        },
        {
            id: 'type',
            name: language[lang].field_type,
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
            cell: row => (
                row?.info?.edition_archive_entregas?.data_entrega !== undefined
                    ? <span className="badge bg-success">{language[lang].entregas ?? 'Entrega'}</span>
                    : <span className="badge bg-warning text-dark">{language[lang].devolucoes ?? 'Devolução'}</span>
            ),
        },
        {
            id: 'btn',
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '10px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none"
                        to={{ pathname: endpoints.view, state: { item: { id: row.info.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                    {permissions.current.edit &&
                        <Link className="button button-update p-0 ps-2"
                            to={{ pathname: endpoints.regist, state: { item: { id: row.info.id }, operation: 'edit' } }} replace>
                            <i className="bi bi-pencil"></i>
                        </Link>
                    }
                    {permissions.current.remove &&
                        <button onClick={() => apagar(row['info']['id'])} className="button btn-delete" style={{ display: 'none' }}>
                            <i className="bi bi-trash"></i>
                        </button>
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data: filtered_data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header mb-8">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center gap-2">
                                                <button
                                                    type="button"
                                                    className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (filter_section.current === 'entregas' ? ' active' : '')}
                                                    onClick={() => { filter_section.current = filter_section.current === 'entregas' ? null : 'entregas'; setRefresh(r => r + 1); }}
                                                >
                                                    {language[lang].entregas ?? 'Entregas'}
                                                </button>

                                                <button
                                                    type="button"
                                                    className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (filter_section.current === 'devolucoes' ? ' active' : '')}
                                                    onClick={() => { filter_section.current = filter_section.current === 'devolucoes' ? null : 'devolucoes'; setRefresh(r => r + 1); }}
                                                >
                                                    {language[lang].devolucoes ?? 'Devoluções'}
                                                </button>
                                            </div>

                                            {permissions.current !== null && (permissions.current.create) && (
                                                <Link
                                                    className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                    to={{ pathname: endpoints.regist }}
                                                    style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                                >
                                                    <span>{language[lang].add_new}</span>
                                                </Link>
                                            )}
                                        </div>

                                        <div className="mt-4 d-none">
                                            {(Array.isArray(array_epis.current) ? array_epis.current : []).some(row => {
                                                const deadline = row.info?.deadline;
                                                if (!deadline) return false;
                                                const diff = (new Date(deadline) - new Date()) / (1000 * 60 * 60 * 24);
                                                return diff <= 30;
                                            }) &&
                                                <span className="badge bg-danger">
                                                    <i className="bi bi-exclamation-triangle-fill me-1"></i>
                                                    {language[lang].deadline_alert ?? 'Substituições próximas ou expiradas'}
                                                </span>
                                            }
                                        </div>
                                    </div>

                                    <div className="table-body">
                                        <div className="row">
                                            <div className="col-12 mb-3 d-flex">
                                                {types_actives.current !== undefined && types_actives.current !== null ?
                                                    types_actives.current.map((dt_el, dt_key) => (
                                                        <div key={dt_key}>
                                                            <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el.id) === parseInt(type_active.current) ? ' active' : '')} onClick={() => change_type(dt_el.id)}>
                                                                {dt_el.info.name}
                                                            </button>
                                                        </div>
                                                    ))
                                                    : null
                                                }
                                            </div>
                                        </div>

                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                defaultSortAsc={true}
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                customStyles={{
                                                    rows: { style: { cursor: 'pointer', minHeight: '24px' } },
                                                    headCells: { style: { padding: '2px', fontSize: '12px' } },
                                                    cells: { style: { padding: '2px', fontSize: '12px' } },
                                                }}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}